module.exports = __webpack_public_path__ + "img/care1.b25e4def.jpg";